import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import { Link } from "react-router-dom";
import useAppsTesting from "../hooks/AppsTestingHook";
import { useTheme } from "@mui/material/styles";
import SchoolNotificationButton from "../../../CcpConstants/SchoolNotificationButton";
import GetCoordIds from "../../../CcpConstants/GetCoordIds";

const StudentApplicationReport = ({ schoolId, linkColor }) => {
  const { data, loading } = useAppsTesting(schoolId);
  const {
    pathwayEmail,
    opEmail,
    loading: emailsLoading,
    error: emailsError,
  } = GetCoordIds(schoolId);
  const theme = useTheme();

  useEffect(() => {
    console.log("schoolId:", schoolId); // Log the schoolId
    console.log("pathwayEmail:", pathwayEmail); // Log pathwayEmail
    console.log("opEmail:", opEmail); // Log opEmail
    console.log("emailsLoading:", emailsLoading); // Log the loading state for emails
    if (emailsError) {
      console.error("Error fetching emails:", emailsError);
    }
    if (data && data.length > 0) {
      console.log("report_1_link", data[0].report_1_link);
    }
  }, [schoolId, pathwayEmail, opEmail, emailsLoading, emailsError, data]); // Add all dependencies

  if (loading || emailsLoading) {
    // Include emailsLoading in the conditional rendering check
    return <div>Loading...</div>;
  }

  if (emailsError) {
    return <div>Error: {emailsError.message}</div>; // Display error message if there's an issue fetching emails.
  }

  const report_2_link = data.length > 0 ? data[0].report_2_link : "#";
  const subject = "Student Application Report";

  return (
    <Card>
      <CardHeader
        title="Student Application Report"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {report_2_link && (
          <>
            <Link
              to={report_2_link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: linkColor }}
            >
              View Report
            </Link>
            <SchoolNotificationButton
              subject={subject}
              schoolId={schoolId}
              pathwayEmail={pathwayEmail}
              opEmail={opEmail}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default StudentApplicationReport;
